<template>
	<div class="pro-tip">
    <div class="row giant">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      {{label}}
    </div>
    <div class="row">
      <p v-html="msg"></p>
    </div>
	</div>
</template>

<script>
    export default {
        props: {
            msg: {
                type: String
            },
            label: {
                type: String,
                default: "Pro Tip"
            }
        },
        data: function () {
            return {};
        },
        methods: {
        },
        computed: {
            message: function () {
                return "Message: " + this.msg;
            }
        }
    };
</script>

<style scoped="">
    .giant {
        font-size: 2.5rem;
        font-weight: bold;
    }

    @media only screen and (min-width: 2830px) {
        .pro-tip {
            float: left;
            position: absolute;
            left: 55%;
        }
    }
</style>



// WEBPACK FOOTER //
// ProTip.vue?08d37aa4